const info = (...args: any[]) => {
  try {
    // @ts-ignore
    window.Rollbar.info(...args);
  } catch (e) {
    console.log(...args);
    // If we can't log it, we can't log it
  }
};

const error = (...args: any[]) => {
  try {
    // @ts-ignore
    window.Rollbar.error(...args);
  } catch (e) {
    console.log(...args);
    // If we can't log it, we can't log it
  }
};

export default { info, error };
